import React from 'react';
import { Hero } from '../components/Home/Hero';
import { ProductsOverview } from '../components/Home/ProductOverview';
import { Box } from '@mui/material';
import { IndustrySection } from '../components/Services/IndustrySection';
import { FadeInSection } from '../components/Animations/FadeInAnimation';

export const HomePage: React.FC = () => {
  return (
    <Box component="main">
      <Hero />
      <FadeInSection delay={0.2}>
        <ProductsOverview />
      </FadeInSection>
       <FadeInSection delay={0.4}>
        <IndustrySection />
      </FadeInSection>
    </Box>
  );
};